import React from "react";
import {Grid} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import {Colors} from "../../../theme/colors";
import {StyledInput} from "../../form/input";


export const EditProfileFormStep2: React.FC<Props> =
	({
		 handleChange,
		 setFieldValue,
		 values,
		 errors,
		 touched
	 }) => {
		const {t} = useTranslation(['publisher', 'common']);

		return <>
			<Grid container direction="column" alignContent="center">
				<StyledTitle>{t('editProfile.step2Title')}</StyledTitle>
				<Grid item container direction="column" sm={12} md={6} spacing={2}>
					<Grid item sm={12}>
						<StyledInput
							id="contactPerson"
							label={t('editProfile.form.contactPerson')}
							onChange={handleChange}
							value={values.contactPerson}
						/>
					</Grid>

					<Grid item container direction={"row"}>
						<Grid item>
							<StyledInput
								id="phonePrefix"
								label={t('editProfile.form.phonePrefix')}
								onChange={handleChange}
								value={values.phonePrefix}
								placeholder={'+48'}
							/>
						</Grid>

						<StyledInputContainer item>
							<StyledInput
								id="phone"
								label={t('editProfile.form.phone')}
								onChange={handleChange}
								value={values.phone}
							/>
						</StyledInputContainer>
					</Grid>

					<Grid item sm={12}>
						<StyledInput
							id="contactEmail"
							label={t('editProfile.form.contactEmail')}
							onChange={handleChange}
							value={values.contactEmail}
							error={errors.contactEmail && touched.contactEmail}
						/>
					</Grid>
				</Grid>
			</Grid>
		</>;
	}

interface Props {
	handleChange: any;
	setFieldValue: any;
	values: any;
	errors: any;
	touched: any;
}

const StyledTitle = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

const StyledSmallTitle = styled('p')`
  color: ${Colors.darkOrange};
  font-size: 1rem;
  font-weight: 500;
`;

const StyledInputContainer = styled(Grid)`
  margin-left: 5px;
  flex: 1;
`;
